import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  class: "input-text-tool"
};
var _hoisted_2 = {
  key: 0,
  style: {
    "width": "18px"
  },
  src: "https://www.bio-cloud.com.cn:8022/icon/loading.gif",
  alt: ""
};
var _hoisted_3 = {
  key: 0,
  class: "files"
};
var _hoisted_4 = {
  key: 0,
  class: "files_model"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  key: 1,
  class: "files_file"
};
var _hoisted_7 = {
  class: "files_file_txt"
};
var _hoisted_8 = ["disabled", "placeholder"];
import { ref, watchEffect } from 'vue';
import { flieUpload } from '@/api/apis';
import { systemType } from '@/constants';
export default {
  __name: 'aiinput',
  props: ['placeholder_txt'],
  emits: ['handle_sendmessage'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var userInput = ref("");
    var placeholder_txtown = ref("请输入你想问的问题...");
    var emit = __emit;
    var props = __props;
    var fileown = ref({});
    var action = process.env.VUE_APP_BASE_URL + '/api/file/add_file';
    var headers = {
      'system-type': systemType,
      Authorization: 'Bearer ' + localStorage.getItem('token_blk')
    };
    var isnotloading = ref(true); //不是上传文件中
    var sendMessage = () => {
      if ((userInput.value.trim() != "" || fileown.value.file_url) && isnotloading.value && placeholder_txtown.value != "正在回答问题中...") {
        var question = userInput.value;
        var file = fileown.value;
        userInput.value = ""; // 清空输入框
        fileown.value = {};
        emit('handle_sendmessage', question, file);
      }
    };
    watchEffect(() => {
      if (props.placeholder_txt) {
        placeholder_txtown.value = props.placeholder_txt;
      }
    });
    // 上传文件
    var handle_upload_file = file => {
      fileown.value.name = file.name;
      fileown.value.type = file.type.indexOf('image') != -1 ? 'image' : 'file';
      fileown.value['question_type'] = 'question';
      var formData = new FormData();
      formData.append("file", file);
      formData.append('content_type', 5);

      // 将图片上传到服务器并返回一个url地址
      flieUpload(formData, 'POST').then(res => {
        var _res$data, _res$data2;
        isnotloading.value = true;
        fileown.value['file_url'] = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.file_url;
        fileown.value['file_id'] = (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.file_id;
      });
    };
    var handleDrop = event => {
      // 阻止默认行为（如打开文件）
      console.log("开始拖拽了", event);
      console.log("e.dataTransfer.files--->", event.dataTransfer.files);
      if (event.dataTransfer.files && event.dataTransfer.files[0]) {
        isnotloading.value = false;
        handle_upload_file(event.dataTransfer.files[0]);
      }
      event.preventDefault();
    };
    var handleDragover = event => {
      event.preventDefault();
      event.dataTransfer.dropEffect = 'copy';
    };
    var handle_del = () => {
      // 删除文件
      fileown.value = {};
    };

    // 工具栏文件上传成功的回调
    var handle_success = (e, file, filetype) => {
      var _e$data, _e$data2;
      console.log("上传->", e, file);
      isnotloading.value = true;
      fileown.value.type = file.raw.type.indexOf('image') != -1 ? 'image' : 'file';
      if (filetype == 'meeting') {
        fileown.value.type = 'audio';
      }
      fileown.value['question_type'] = filetype;
      fileown.value['file_url'] = e === null || e === void 0 || (_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.file_url;
      fileown.value['file_id'] = e === null || e === void 0 || (_e$data2 = e.data) === null || _e$data2 === void 0 ? void 0 : _e$data2.file_id;
      fileown.value['name'] = file.name;
    };
    var handle_progress = e => {
      // console.log("e--->", e)
      isnotloading.value = false;
    };
    return (_ctx, _cache) => {
      var _component_el_upload = _resolveComponent("el-upload");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_upload, {
        disabled: _unref(placeholder_txtown) == '正在回答问题中...',
        headers: headers,
        data: {
          content_type: 5
        },
        action: action,
        "show-file-list": false,
        accept: ".docx,.txt",
        "on-success": (response, file) => {
          return handle_success(response, file, 'translate');
        },
        "on-progress": handle_progress
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createElementVNode("span", {
          class: "toolbtn"
        }, "翻译文件", -1)])),
        _: 1
      }, 8, ["disabled", "on-success"]), _createVNode(_component_el_upload, {
        disabled: _unref(placeholder_txtown) == '正在回答问题中...',
        headers: headers,
        data: {
          content_type: 5
        },
        action: action,
        "show-file-list": false,
        accept: ".png,.jpg,.jpeg",
        "on-success": (response, file) => {
          return handle_success(response, file, 'image');
        },
        "on-progress": handle_progress
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("span", {
          class: "toolbtn"
        }, "识别图片", -1)])),
        _: 1
      }, 8, ["disabled", "on-success"]), _createVNode(_component_el_upload, {
        disabled: _unref(placeholder_txtown) == '正在回答问题中...',
        headers: headers,
        data: {
          content_type: 5
        },
        action: action,
        "show-file-list": false,
        accept: ".mp3,.wav,.pcm,.m4a,.amr",
        "on-success": (response, file) => {
          return handle_success(response, file, 'meeting');
        },
        "on-progress": handle_progress
      }, {
        default: _withCtx(() => [_cache[3] || (_cache[3] = _createElementVNode("span", {
          class: "toolbtn"
        }, "生成会议纪要", -1)), !_unref(isnotloading) ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["disabled", "on-success"])]), _createElementVNode("div", {
        class: "input-text",
        onDragover: _withModifiers(handleDragover, ["prevent"]),
        onDrop: handleDrop
      }, [_unref(fileown) && _unref(fileown).type ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_unref(fileown).type == 'image' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("img", {
        src: _unref(fileown).file_url,
        alt: ""
      }, null, 8, _hoisted_5), _createElementVNode("span", {
        class: "iconfont icon-guanbi1",
        onClick: handle_del
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString(_unref(fileown).name), 1), _createElementVNode("span", {
        class: "iconfont icon-guanbi1",
        onClick: handle_del
      })]))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("textarea", {
        disabled: _unref(placeholder_txtown) == '正在回答问题中...',
        class: "el-textarea__inner",
        autocomplete: "off",
        placeholder: _unref(placeholder_txtown),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => userInput.value = $event),
        style: {
          "min-height": "100px"
        },
        onKeyup: _withKeys(sendMessage, ["enter"])
      }, null, 40, _hoisted_8), [[_vModelText, userInput.value]]), _createElementVNode("div", {
        class: "input-text-footer"
      }, [_createElementVNode("span", {
        class: "iconfont icon-fasong",
        onClick: sendMessage
      })])], 32)]);
    };
  }
};